export default __webpack_public_path__ + "static/media/06.9e63dd31.jpg";